import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import useFetch from '../Utilities/useFetch';
import ReactSelect from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Row, Col } from 'react-bootstrap'

const { REACT_APP_API_URL } = process.env;

const ReportTemplateCollectorNoClick = ({
    columnDefs,
    apiUrl,
    reportName
}) => {
    const [collector, setCollector] = useState(null);
    const [date, setDate] = useState('');
    const [rowData, setRowData] = useState([]);
    const [collectorOptions, setCollectorOptions] = useState([]);
    const [gridApi, setGridApi] = useState();
    const onBtnExport = () => {
        const textColumns = ['Claim ID', 'clientRefNo', 'RefNo']; // columns to format as text
        const dateColumns = ['listDate', 'time','date','serviceDate', 'arbHearingDate', 'accountStatusDate', 'depositDate', 'dateReceived', 'dateRemitted']; // columns to format as date
        gridApi.exportDataAsCsv({
            processCellCallback: (params) => {
                if (textColumns.includes(params.column.getColId())) {
                    return params.value != null ? "'" + params.value : '';
                }
                if (dateColumns.includes(params.column.getColId())) {
                    if (params.value == null) return '';
                    const date = new Date(params.value);
                    const formattedDateTime = isNaN(date.getTime())
                        ? ''
                        : date.toLocaleString('en-US', {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit',
                              second: '2-digit'
                          });

                    return formattedDateTime;
                }
                return params.value;
            }
        });
    }
    const onGridReady = (params) => {
        setGridApi(params.api);
    }
    // Fetch collectors for dropdown
    const { data: collectors, error: collectorsError } = useFetch(
        true,
        `${REACT_APP_API_URL}/Claims/GetCollectors`,
        'GET'
    );

    // Fetch report data based on selected collector
    const { data, error } = useFetch(
        !!collector, // Only fetch when collector is selected
        apiUrl,
        'GET',
        null,
        { collector: collector?.value, startDate: date || null }
    );

    // Set up collector options for dropdown
    useEffect(() => {
        if (collectors) {
            const options = collectors.map(obj => ({
                value: obj.key,
                label: obj.value
            }));
            setCollectorOptions(options);
        }
    }, [collectors]);

    // Update row data when data changes
    useEffect(() => {
        if (data) {
            setRowData(data);
        }
    }, [data]);

    // Clear data on error
    useEffect(() => {
        if (error) {
            setRowData([]);
            console.error('Error fetching data:', error);
        }
    }, [error]);
     const handleDateChange = (newDate) => {
        setDate(newDate);
    };
    
    const DatePicker = ({ value }) => {
        return (
            <input
                type="date"
                value={value}
                onChange={(e) =>  handleDateChange(e.target.value)}
            />
        );
    };

    const handleCollectorChange = (selectedOption) => {
        setCollector(selectedOption);
        if (selectedOption) {
            // Set date to yesterday in PST when collector is selected
            const today = new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
            const pstDate = new Date(today);
            pstDate.setDate(pstDate.getDate() - 1);
            setDate(pstDate.toISOString().split('T')[0]);
        }
    };

    return (
        <div>
            <h4 className='margin'>{reportName}</h4>
            <Row>
                <Col className='collector-picker'>


                    <label htmlFor="collector-select">Select Collector: &nbsp;</label>
                    <ReactSelect
                        id="collector-select"
                        value={collector}
                        onChange={handleCollectorChange}
                        options={collectorOptions}
                        placeholder="Select a collector..."
                        isClearable
                        isSearchable
                        className="collector-dropdown"
                        styles={{ container: (base) => ({ ...base, minWidth: '200px', display: 'inline-block' }) }}
                    />
                    <DatePicker value={date} onChange={setDate} /> 
 
                    <span> &nbsp; Row Count: {rowData.length}</span>
                </Col>
                <Col className='export-button'>
                    <Button variant='secondary' onClick={onBtnExport}>Download CSV</Button>
                </Col>
            </Row>
            {collectorsError && <div className="error-message">Error loading collectors: {collectorsError.message}</div>}
            {error && <div className="error-message">Error fetching data: {error.message}</div>}
            <div className="ag-theme-quartz compact-theme grid">
                <AgGridReact
                    rowData={rowData}
                    onGridReady={onGridReady}

                    columnDefs={columnDefs}
                    defaultColDef={{ sortable: true, filter: true, resizable: false }}
                />
            </div>
        </div>
    );
};

export default ReportTemplateCollectorNoClick;